import { AttachmentService, AttachmentType, type AttachmentDetails } from "@/services/AttachmenteService";
import { useEffect, useState } from "react";
import { FileUploadCopied } from "../ui/FilesUploadCopied";
import ImageList from "../ImageList";

interface FeatureGalleryProps {
  featureId: string;
  siteId: string;
  tenantId: string;
}

const FeatureGallery: React.FC<FeatureGalleryProps> = ({ featureId, siteId, tenantId }) => {
  const [selectedAttachments, setSelectedAttachments] = useState<AttachmentDetails[]>([])

  useEffect(() => {
    const fetchAttachments = async () => {
      const attachments = await AttachmentService.getByEntityId(featureId);
      setSelectedAttachments(attachments);
    };
    fetchAttachments();
  }, [featureId]);

  return (
    <>  
      <div className="flex flex-col justify-evenly pt-2">
      <div className="mb-2">
        <FileUploadCopied
          entityId={featureId}
          siteId={siteId}
          tenantId={tenantId}
          entityType="Feature"
          attachmentType={AttachmentType.None}
          buttonText="Select Images"
          onFileUploaded={(attachment: AttachmentDetails) => {
            // Add attachment to the selectedAttachments state
            setSelectedAttachments(prev => [ 
              { 
                ...attachment, 
                uploadDate: new Date(attachment.dateTaken ?? attachment.uploadDate).toISOString() 
              }, 
              ...prev
            ]);
          }}
        />
      </div>
      
        {/* <FilesUpload initalImageUrl={null} onAttachmentsUploaded={(attachments) => setSelectedAttachments(prev => [...mapAttachments(attachments), ...prev])} entityId={featureId} /> */}
      </div>

      <div className="grow">
        <div className="flex flex-col md:flex-row gap-1">
          <ImageList
            attachmentColumn={true}
            attachments={selectedAttachments}
            onAttachmentsChange={setSelectedAttachments}
            onDeleteAttachment={(attachmentId: string) => {
              try {
                AttachmentService.delete(attachmentId);
                setSelectedAttachments(prev => prev.filter(att => att.id !== attachmentId));
              } catch (error) {
                alert("Error deleting attachment");
                throw error;
              }
            }}
          />
        </div>
      </div> 
    </>
  );
};

export default FeatureGallery;
